import React, { useState } from "react";
import ExpiredSubscription from "layouts/components/Upgrade/expired";

const RequireSubscriptionNotExpired = ({ activeSubscription, initialLoadComplete, children }) => {
    // 1. Check if subscription exists (likely during re-validation)
    if (!activeSubscription) {
        if (!initialLoadComplete) return null; // Initial boot safety
        return children; // Seamless background update
    }

    // 2. Renewal Date Check
    const renewalDate = activeSubscription.next_renewal_date
        ? new Date(activeSubscription.next_renewal_date)
        : null;

    // If no renewal date (e.g. lifetime?), assume valid.
    if (!renewalDate) {
        return children;
    }

    const now = new Date();

    if (now > renewalDate) {
        // "associated workspaceSubscription has expired"
        return <ExpiredSubscription />;
    }

    return children;
};

export default RequireSubscriptionNotExpired;
